var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    menu_admin: [],
    selected_item_children: [],
    pageAdminLayout: false,
    selected_menu: [],
};
export var administrationSlice = createSlice({
    name: "adminMenu",
    initialState: initialState,
    reducers: {
        setMenuAdmin: function (state, data) {
            state.menu_admin = data.payload;
        },
        setSelectedItemChildren: function (state, data) {
            state.selected_item_children = data.payload;
        },
        setPageAdminLayout: function (state, data) {
            state.pageAdminLayout = data.payload;
        },
        setSelectedMenu: function (state, data) {
            state.selected_menu = data.payload;
        },
    },
});
export var setMenuAdmin = (_a = administrationSlice.actions, _a.setMenuAdmin), setSelectedItemChildren = _a.setSelectedItemChildren, setPageAdminLayout = _a.setPageAdminLayout, setSelectedMenu = _a.setSelectedMenu;
export default administrationSlice.reducer;
